module.exports = __webpack_public_path__ + "img/imgZXGH(13).d310e87f.png";